
export default {
  name: 'Select',

  props: {
    dropdownitems: {
      type: Array,
      default() {
        return []
      },
    },
    text: {
      type: String,
      default: 'option',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: 'selectname',
    },
    label: {
      type: String,
      default: '',
    },

    option: {
      type: String,
      default: '',
    },
    keyName: {
      type: String,
      default: '',
    },
    valueName: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    thin: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      focused: false,
      selected: '',
    }
  },

  computed: {
    computedClass() {
      return {
        'dropdown--focused': this.focused,
        'dropdown--disabled': this.disabled,
      }
    },

    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },

  watch: {
    selected() {
      this.$emit('selected', this.selected)
    },
  },
}
